module.exports = __webpack_public_path__ + "img/Flag_of_the_Republic_of_China.45ef6b69.svg";